import React from "react";
import PaymentEntry from "../../components/PaymentEntry/PaymentEntry";
import Layout from "../../components/shared/Layout/Layout";

const PaymentEntryPage = () => {
  return (
    <div className="bg_light">
      <Layout title="Payment Entry">
        <PaymentEntry />
      </Layout>
    </div>
  );
};

export default PaymentEntryPage;

